import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-input-field',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.css']
})
export class InputFieldComponent {
  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() id!: string;
  @Input() label!: string;
  @Input() type: string = 'text';
  @Input() submitted: boolean = false;
  @Input() errorMessage: string = 'This field is required';
  @Input() minMaxErrorMessage: string = 'This field is required';
  @Input() hasError: boolean = false; // New input for error highlighting

  @Output() inputChange = new EventEmitter<Event>();
  @Output() inputBlur = new EventEmitter<Event>();  // New output for blur

  onInputChange(event: Event): void {
    this.inputChange.emit(event);
  }

  onInputBlur(event: Event): void {
    this.inputBlur.emit(event);  // Emit the blur event
  }
}